import React from "react";
import LegacySettingsTab from "./SettingsTab/LegacySettingsTab";
import SettingsTabV2 from "./settingsTabV2/SettingsTabV2";
import EspressoBeveragesTab from "./EspressoBeveragesTab";
import OkcSettingsTab from "./okcSettingsTab/OkcSettingsTab";
import { isOkcDevice } from "./okcSettingsTab/okcSettingsModel";

// v2 settings unified protocol (settings/READ + settings/WRITE topics).
// Esik 2.45.0 -> 2.20.0'a indirildi: 2.20+ build'ler bu topic'lere abone
// kabul ediliyor; altindakiler LegacySettingsTab'e duser.
const MIN_V2_APP_VERSION = [2, 20, 0];

const isV2AppVersion = (versionStr) => {
  if (!versionStr) return false;
  const m = String(versionStr).match(/(\d+)\.(\d+)\.(\d+)/);
  if (!m) return false;
  const [major, minor, patch] = [m[1], m[2], m[3]].map((n) => parseInt(n, 10));
  if (![major, minor, patch].every(Number.isFinite)) return false;
  const [minMajor, minMinor, minPatch] = MIN_V2_APP_VERSION;
  if (major !== minMajor) return major > minMajor;
  if (minor !== minMinor) return minor > minMinor;
  return patch >= minPatch;
};

const SettingsTab = ({ selectedDevice, setAlerts, isDrawer = false }) => {
  // Espresso (Kalerm) modelinde Ayarlar; genel/göz/profil yerine doğrudan
  // içecek listesini (Kalerm 2.4 senkronlu, fiyat düzenlemeli) gösterir.
  const deviceName =
    selectedDevice?.deviceInfo?.deviceName ||
    selectedDevice?.deviceName ||
    "";
  if (deviceName.includes("Espresso")) {
    return (
      <EspressoBeveragesTab selectedDevice={selectedDevice} setAlerts={setAlerts} />
    );
  }

  // Eski kart seti Türk kahvesi (4G kartı, hwVersion OKC63): tablet değil,
  // kendi ayar listesi var (#325, okc-settings.md).
  if (isOkcDevice(selectedDevice)) {
    return (
      <OkcSettingsTab selectedDevice={selectedDevice} setAlerts={setAlerts} isDrawer={isDrawer} />
    );
  }

  const versionStr =
    selectedDevice?.deviceInfo?.appVersion ||
    selectedDevice?.deviceInfo?.uiVersion;
  const isV2 = isV2AppVersion(versionStr);
  return isV2 ? (
    <SettingsTabV2 selectedDevice={selectedDevice} setAlerts={setAlerts} isDrawer={isDrawer} />
  ) : (
    <LegacySettingsTab
      selectedDevice={selectedDevice}
      setAlerts={setAlerts}
      isDrawer={isDrawer}
    />
  );
};

export default SettingsTab;
